import { render, staticRenderFns } from "./media_block.vue?vue&type=template&id=add6e2b8&scoped=true&lang=pug"
import script from "./media_block.vue?vue&type=script&lang=js"
export * from "./media_block.vue?vue&type=script&lang=js"
import style0 from "./media_block.vue.css?vue&type=style&index=0&id=add6e2b8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add6e2b8",
  null
  
)

export default component.exports